import axios_org from "axios";

const axios = axios_org.create({
  baseURL: "https://jagahdekhoadmin.techtracesolution.com/api/",
});

export default axios;
